<div class="one-dialog">
    <div class="dialog-header d-flex">
        <div class="title flex-grow-1">
            <h2 mat-dialog-title>{{title}}</h2>
        </div>
        <div class="right">
            <button mat-icon-button mat-dialog-close aria-label="Close dialog icon">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="dialog-body">
            <form [formGroup]="requestFormGroup">
                <div class="row">
                    <div class="col-md-3">
                        <div class="label form-label">{{text.REQUEST_TITLE}} *</div>
                    </div>
                    <div class="col-md-9">
                        <mat-form-field class="full" appearance="outline" color="warn">
                            <mat-label>{{text.REQUEST_TITLE}}</mat-label>
                            <input matInput placeholder="{{text.REQUEST_TITLE}}" formControlName="name">
                            <mat-error *ngIf="requestFormGroup.controls.name.invalid">Vui lòng nhập tên đề xuất</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="label form-label">{{text.GROUP}} *</div>
                    </div>
                    <div class="col-md-9">
                      <mat-form-field appearance="fill" class="full" >
                        <mat-select required formControlName="requestGroup" #singleSelect [disabled]="isEdit">
                          <mat-option>
                            <ngx-mat-select-search placeholderLabel="Tìm kiếm"
                              noEntriesFoundLabel="Không tìm thấy"
                              [formControl]="requestGroupFilter"></ngx-mat-select-search>
                          </mat-option>
                          <mat-option *ngFor="let requestGroup of filteredRequestGroups | async" [value]="requestGroup">
                            {{requestGroup.name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div style="color:#888; font-style:italic">
                          {{groupDescription}}
                      </div>
                    </div>
                </div>
                <div>
                  <request-group-template [requestGroup]="getCurrentRequestGroup()" [oneControl]="requestFormGroup.controls.requestGroupData" [attrObservable]="attrSubject.asObservable()" (attrEmitter)="onAttrEventReceived($event)" [requestId]="requestId" ></request-group-template>
                </div>
              <div class="row" *ngIf="requestFormGroup.controls.requestGroup.value != null && requestFormGroup.controls.requestGroup.value.mgmtNotification == true">
                <div class="col-md-3">
                  <div class="label form-label">Quản lý trực tiếp *</div>
                </div>
                <div class="col-md-9">
                  <one-user-select [allUsers]="allUsers" [oneControl]="requestFormGroup.controls.directMgmts" [isDisabled]="isEdit == true"></one-user-select>
                  <mat-error *ngIf="requestFormGroup.controls.directMgmts.invalid">Vui lòng chọn người quản lý trực tiếp</mat-error>
                </div>
              </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="label form-label">{{text.APPROVER}} *</div>
                    </div>
                    <div class="col-md-9">
                        <one-user-select [allUsers]="allUsers" [oneControl]="requestFormGroup.controls.approvers" [isDisabled]="directRequest == false"></one-user-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="label form-label">{{text.FOLLOWER}}</div>
                    </div>
                    <div class="col-md-9">
                        <one-user-select [allUsers]="allUsers"
                                        [oneControl]="requestFormGroup.controls.followers"
                                        [fixedUserControl]="requestFormGroup.controls.fixedUsers"></one-user-select>
                    </div>
                </div>
                <one-file-control [oneControl]="attachmentInfo.oneControl"
                                    [attribute]="attachmentInfo.attr"
                                    [parentId]="requestId"></one-file-control>
            </form>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>{{text.CANCEL}}</button>
        <button mat-raised-button color="warn" (click)="submitRequest()" [disabled]="submitted">{{saveText}}</button>
    </mat-dialog-actions>
</div>
